import { OrbitProgress } from "react-loading-indicators"

const LoadingWrapper = ({children, loading, viewStyle = {}, color = '#3F4FE0', size = 'medium', render}) => {
    return loading ? render ? render : (
        <OrbitProgress color={color} size={size} style={viewStyle} />
    ) : children
}

export default LoadingWrapper